import { PageLayoutSidebar } from '../PageLayout';
import { MenuFoldOutIcon, MenuFoldInIcon } from '@/components/Icons';
import SidebarMenu from './SidebarMenu';
import { Link, useRouteMatch } from 'react-router-dom';
import { Icon } from '../primitives/icon/Icon';
import AccountSettingsTabs from './AccountSettingsTabs';
import { CreateDropdownButton } from './CreateDropdownButton';
import { useUserContext } from '@/contexts/UserContext';

const SIDEBAR_WIDTH_COLLAPSED = 'w-[56px]';
const SIDEBAR_WIDTH_EXPANDED = 'w-[260px]';

export function Sidebar() {
  const { sidebarCollapsed, setValue } = useUserContext();
  const isSettingsRoute = useRouteMatch({ path: ['/settings', '/settings/*'] });
  const sidebarClasses = !sidebarCollapsed
    ? `transform transition-transform duration-300 ${SIDEBAR_WIDTH_EXPANDED}`
    : `transform transition-transform duration-300 ${SIDEBAR_WIDTH_COLLAPSED}`;

  const toggleSidebar = (collapsed: boolean) => {
    setValue((prev) => ({ ...prev, sidebarCollapsed: collapsed }));
  };

  return (
    <PageLayoutSidebar className="text-xs text-content-primary pt-4 flex flex-col border-r border-default bg-surface">
      <div className={sidebarClasses}>
        {isSettingsRoute ? (
          !sidebarCollapsed ? (
            <>
              <div className="flex items-center justify-between">
                <Link to="/" className="btn btn-primary flex ml-4 text-lg font-light">
                  <Icon name="left" className="mr-3 mt-1"></Icon> <span className="">Back</span>
                </Link>
                <MenuFoldOutIcon
                  className="w-4 h-4 text-content-primary cursor-pointer mr-3"
                  onClick={() => toggleSidebar(true)}
                />
              </div>
              <div className="flex mb-8 ml-6 my-8 text-content-primary text-sm">
                <Icon name="gear" className="h-4 w-4 mt-[2px]" />
                <span className="ml-2">Account Settings</span>
              </div>
              <div className="mt-8 bg-surface flex">
                <AccountSettingsTabs />
              </div>
            </>
          ) : (
            <div className={`flex flex-col justify-between h-[90vh] ${SIDEBAR_WIDTH_COLLAPSED}`}>
              <div className="flex items-center justify-center pt-4">
                <MenuFoldInIcon
                  className="w-4 h-4 text-content-primary cursor-pointer mt-[1px]"
                  onClick={() => toggleSidebar(false)}
                />
              </div>
            </div>
          )
        ) : !sidebarCollapsed && !isSettingsRoute ? (
          <SidebarMenu onSidebarOpenClose={toggleSidebar} sidebarOpen={!sidebarCollapsed} />
        ) : (
          <div className={`flex flex-col justify-between h-[90vh] ${SIDEBAR_WIDTH_COLLAPSED}`}>
            <div className="flex items-center justify-center pt-4">
              <MenuFoldInIcon
                className="w-4 h-4 text-content-primary cursor-pointer mt-[1px]"
                onClick={() => toggleSidebar(false)}
              />
            </div>
            <div></div>
            <div className={`flex flex-col items-center justify-center ${SIDEBAR_WIDTH_COLLAPSED}`}>
              <div className="w-[32px] bg-border-default h-px mb-4 mx-4"></div>
              <CreateDropdownButton variant="compact" />
            </div>
          </div>
        )}
      </div>
    </PageLayoutSidebar>
  );
}
